export default "__VITE_ASSET__D20b_rWu__"